export default "__VITE_ASSET__DqAcC0oG__"